import { Fragment } from 'react';
import { _ } from '/@/locale';
import { isMobile } from '/@/utils';
import Dots from '/@/v3/components/dots';
import styles from './styles.module.css';

export const DotsReference = ({ brand, country }) => {
    const mobile = isMobile();
    const type = brand.type;
    const name = String(country) ? country : country.name;

    return (
        <div className={styles.root}>
            <div className={styles.title}>{_('Referencias')}</div>
            <div className={styles.dots}>
                <div className={styles.labels}>
                    {type === 'soy' && name === 'Brasil' ? (
                        <Fragment>
                            <div>{_('Resistente')}</div>
                            {brand.metricsMaxValue !== 9 && !mobile && <div>{_('Moderadamente \n resistente')}</div>}
                        </Fragment>
                    ) : (
                        <Fragment>
                            <div>{_('Tolerante')}</div>
                            {brand.metricsMaxValue !== 9 && !mobile && <div>{_('Moderadamente \n tolerante')}</div>}
                        </Fragment>
                    )}
                    {brand.metricsMaxValue !== 4 && <div>{_('Moderado')}</div>}
                    {brand.metricsMaxValue !== 9 && !mobile && <div>{_('Moderadamente \n susceptible')}</div>}
                    <div>{_('Susceptible')}</div>
                </div>
                <div className={styles.dotContainer}>
                    <Dots
                        max={brand.metricsMaxValue}
                        theme={brand.theme}
                        reference
                        showValues={brand.showMetricsValues}
                        monochrome={brand.showMetricsUsingBrandTheme}
                    />
                </div>
            </div>
        </div>
    );
};
